module.exports = __webpack_public_path__ + "img/alertWardInfoGreen.8c88189e.svg";